import React, { useRef } from "react";
import { Control, Controller, FieldErrors, FieldValues } from "react-hook-form";
import InputMask from "react-input-mask";
import { Box, TextField } from "@mui/material";
import { handleHelperText } from "../shared/utils/helper-text-handler";
import { handleEndAdornment } from "../shared/utils/end-adornment-icon-handler";
import InputLabel from "../layoutComponents/InputLabel";
import { formErrorRules } from "../shared/utils/form-error-rules";
import { AutocompleteStyles } from "../shared/utils/autocomplete-styles";

interface TextFieldInputProps {
	name: string;
	control: Control;
	label: string;
	reset: (data: any) => void;
	errors: FieldErrors<FieldValues>;
	defaultValue: string;
	setValue: (fieldName: any, value: string) => void;
	tabValue: number;
	disabled: boolean;
	gutterBottom?: boolean;
}

const PhoneNumberInput = ({
	name,
	control,
	label,
	errors,
	defaultValue,
	setValue,
	tabValue,
	disabled,
	gutterBottom = true,
}: TextFieldInputProps) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const classes = AutocompleteStyles();

	return (
		<Box marginBottom={gutterBottom ? 2 : 0}>
			{label && <InputLabel>{label}</InputLabel>}
			<Controller
				name={name}
				defaultValue={defaultValue}
				control={control}
				rules={formErrorRules(name)}
				render={({ field: { onChange, value } }) => (
					<InputMask mask={"+4\\20 999 999 999"} value={value} disabled={disabled} maskChar="" onChange={onChange}>
						{() => (
							<TextField
								fullWidth
								error={!!errors[name]}
								disabled={disabled}
								helperText={handleHelperText(errors, name)}
								inputRef={inputRef}
								type="text"
								onChange={onChange}
								value={value}
								InputProps={{
									classes: { root: classes.inputRoot },
									endAdornment: handleEndAdornment(errors, name, setValue, inputRef, disabled),
								}}
								inputProps={{ tabIndex: tabValue }}
							/>
						)}
					</InputMask>
				)}
			/>
		</Box>
	);
};

export default PhoneNumberInput;
